import React from 'react';
import { useAtomValue } from 'jotai';
import { StyledDrawer } from './styled';
import { editIntegrationAtom, isEditCreateFormOpenAtom } from './atoms';
import { useResetPanelAtoms } from './hooks';
import ServiceIntegrationsList from './list';
import { Header } from './header';
import ServiceIntegrationEdit from './edit';

const ServiceIntegrationsDrawer = ({ isOpen, closeDrawer }) => {
  const editIntegration = useAtomValue(editIntegrationAtom);
  const isEditCreateFormOpen = useAtomValue(isEditCreateFormOpenAtom);
  const resetAtoms = useResetPanelAtoms();

  const handleCloseDrawer = () => {
    resetAtoms.reset();
    closeDrawer();
  };

  return (
    <StyledDrawer
      open={isOpen}
      closeIcon={null}
      contentWrapperStyle={{
        width: '85%',
        minWidth: '800px',
      }}
      onClose={handleCloseDrawer}
      keyboard={true}
    >
      <Header closeDrawer={handleCloseDrawer} />
      {!isEditCreateFormOpen && isOpen ? <ServiceIntegrationsList isDrawerOpen={isOpen} /> : null}
      {isEditCreateFormOpen ? (
        <ServiceIntegrationEdit configId={editIntegration?.configId || null} />
      ) : null}
    </StyledDrawer>
  );
};

export default ServiceIntegrationsDrawer;
